import type { RouteRecordRaw } from "vue-router";
import { APP_SETTINGS_ROUTES as SETTINGS } from "@/Generated/Routes/paths";

const invoices: RouteRecordRaw[] = [
  {
    ...SETTINGS.invoices.root,
    component: () => import("@/Views/settings/invoices/index.vue"),
    meta: {
      sidebar: false,
      i18nTitle: "settings.invoices-title",
    },
  },
  {
    ...SETTINGS.invoices.detail.root,
    component: () => import("@/Views/settings/invoices/MonthDetail.vue"),
    meta: {
      sidebar: false,
      i18nTitle: "settings.invoices-title",
    },
  },
];

export default invoices;
